export const ru = {
    cancel: 'Отмена',
    save: 'Назначить',
    title: 'Доступ к пакету "{title}"'
};
